import { render, staticRenderFns } from "./HolidaysList.vue?vue&type=template&id=3208eff8"
import script from "./HolidaysList.vue?vue&type=script&lang=js"
export * from "./HolidaysList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports